import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, perms }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const def = <Navigate to="/UnAuthorized" />;
  const nf = <Navigate to="/NotFound" />;
  // const na = <Navigate to="/NotAvailable" />;
  const includesAny = (arr, values) => values.some((v) => arr.includes(v));
  if (!userData || !userData["user_id"]) {
    return <Navigate to="/Login" />;
  }

  if (perms && perms.length > 0) {
    // if (online) {
    //console.log(children.type.name);
    // console.log(perms);
    if (!includesAny(perms, [10]) && children.type.name === "Overview") {
      return def;
    } else if (
      !includesAny(perms, [44, 45, 46]) &&
      children.type.name === "Stores"
    ) {
      return def;
    } else if (
      !includesAny(perms, [44]) &&
      children.type.name === "ViewStore"
    ) {
      return def;
    } else if (
      !includesAny(perms, [45]) &&
      children.type.name === "AddStore"
    ) {
      return def;
    } else if (
      !includesAny(perms, [46]) &&
      children.type.name === "EditStore"
    ) {
      return def;
    } else if (
      !includesAny(perms, [47, 48, 49]) &&
      children.type.name === "Inventory"
    ) {
      return def;
    } else if (
      !includesAny(perms, [47]) &&
      children.type.name === "ViewInventory"
    ) {
      return def;
    } else if (
      !includesAny(perms, [48]) &&
      children.type.name === "AddOpeningBal"
    ) {
      return def;
    } else if (
      !includesAny(perms, [49]) &&
      (children.type.name === "InStock" ||
        children.type.name === "OutStock" ||
        children.type.name === "TransferStock")
    ) {
      return def;
    } else if (
      !includesAny(perms, [20, 21, 22]) &&
      children.type.name === "Parts"
    ) {
      return def;
    } else if (
      !includesAny(perms, [20]) &&
      children.type.name === "ViewPart"
    ) {
      return def;
    } else if (
      !includesAny(perms, [21]) &&
      children.type.name === "AddPart"
    ) {
      return def;
    } else if (
      !includesAny(perms, [22]) &&
      children.type.name === "EditPart"
    ) {
      return def;
    } else if (
      !includesAny(perms, [23, 24]) &&
      children.type.name === "Serialized"
    ) {
      return def;
    } else if (
      !includesAny(perms, [23]) &&
      children.type.name === "ViewSerialized"
    ) {
      return def;
    } else if (
      !includesAny(perms, [24]) && (
        children.type.name === "AssignSerialized" ||
        children.type.name === "EditSerialized")
    ) {
      return def;
    } else if (
      !includesAny(perms, [33, 34]) &&
      children.type.name === "Kits"
    ) {
      return def;
    } else if (
      !includesAny(perms, [33]) &&
      children.type.name === "View Kit"
    ) {
      return def;
    } else if (
      !includesAny(perms, [34]) && (
        children.type.name === "AddEditKit" ||
        children.type.name === "AddEditKit")
    ) {
      return def;
    } else if (
      !includesAny(perms, [50, 51, 52]) &&
      children.type.name === "Quotes"
    ) {
      return nf;
    } else if (
      !includesAny(perms, [50]) &&
      children.type.name === "ViewQuotation"
    ) {
      return nf;
    } else if (
      !includesAny(perms, [51]) &&
      children.type.name === "AddQuotation"
    ) {
      return nf;
    } else if (
      !includesAny(perms, [52]) &&
      children.type.name === "EditQuotation"
    ) {
      return nf;
    }
    else if (
      !includesAny(perms, [28, 29, 30]) &&
      (children.type.name === "Sales" ||
        children.type.name === "SalesReturns")
    ) {
      return def;
    } else if (
      !includesAny(perms, [28]) &&
      (children.type.name === "ViewSaleOrder" ||
        children.type.name === "ViewShipment" ||
        children.type.name === "ViewSalesReturn")
    ) {
      return def;
    } else if (
      !includesAny(perms, [29]) &&
      (children.type.name === "AddSaleOrder" ||
        children.type.name === "ConvertQuotation" ||
        children.type.name === "Shipment" ||
        children.type.name === "AddSalesReturn")
    ) {
      return def;
    } else if (
      !includesAny(perms, [30]) &&
      (children.type.name === "EditSaleOrder" ||
        children.type.name === "EditSalesReturn")
    ) {
      return def;
    } else if (
      !includesAny(perms, [25, 26, 27]) &&
      (children.type.name === "Purchase" ||
        children.type.name === "SpecialOrders" ||
        children.type.name === "SpecialOrder")
    ) {
      return def;
    } else if (
      !includesAny(perms, [25]) &&
      (children.type.name === "ViewPurchaseOrder" ||
        children.type.name === "ViewReceiveLog")
    ) {
      return def;
    } else if (
      !includesAny(perms, [26]) &&
      (children.type.name === "AddPurchaseOrder" ||
        children.type.name === "ReceiveLog")
    ) {
      return def;
    } else if (
      !includesAny(perms, [27]) &&
      children.type.name === "EditPurchaseOrder"
    ) {
      return def;
    } else if (
      !includesAny(perms, [17, 18, 19]) &&
      children.type.name === "Account"
    ) {
      return def;
    } else if (
      !includesAny(perms, [17]) &&
      children.type.name === "ViewAccount"
    ) {
      return def;
    } else if (
      !includesAny(perms, [18]) &&
      children.type.name === "AddAccount"
    ) {
      return def;
    } else if (
      !includesAny(perms, [19]) &&
      children.type.name === "EditAccount"
    ) {
      return def;
    } else if (
      !includesAny(perms, [11, 12, 13]) &&
      children.type.name === "Customers"
    ) {
      return def;
    } else if (
      !includesAny(perms, [11]) &&
      (children.type.name === "ViewCustomer" ||
        children.type.name === "ViewSale" ||
        children.type.name === "ViewSO")
    ) {
      return def;
    } else if (
      !includesAny(perms, [12]) &&
      children.type.name === "AddCustomer"
    ) {
      return def;
    } else if (
      !includesAny(perms, [13]) &&
      children.type.name === "EditCustomer"
    ) {
      return def;
    } else if (
      !includesAny(perms, [14, 15, 16]) &&
      children.type.name === "Vendor"
    ) {
      return def;
    } else if (
      !includesAny(perms, [14]) &&
      (children.type.name === "ViewVendor" ||
        children.type.name === "ViewPurchase" ||
        children.type.name === "ViewPO")
    ) {
      return def;
    } else if (
      !includesAny(perms, [15]) &&
      (children.type.name === "AddVendor" ||
        children.type.name === "PartAssign")
    ) {
      return def;
    } else if (
      !includesAny(perms, [16]) &&
      children.type.name === "EditVendor"
    ) {
      return def;
    } else if (
      !includesAny(perms, [56, 57, 58]) &&
      children.type.name === "Employee"
    ) {
      return def;
    } else if (
      !includesAny(perms, [56]) &&
      children.type.name === "ViewEmployee"
    ) {
      return def;
    } else if (
      !includesAny(perms, [57]) &&
      children.type.name === "AddEmployee"
    ) {
      return def;
    } else if (
      !includesAny(perms, [58]) &&
      children.type.name === "EditEmployee"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37, 38, 39]) &&
      children.type.name === "Receipt"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37]) &&
      children.type.name === "ViewReceipt"
    ) {
      return def;
    } else if (
      !includesAny(perms, [38]) &&
      children.type.name === "AddReceipt"
    ) {
      return def;
    } else if (
      !includesAny(perms, [39]) &&
      children.type.name === "EditReceipt"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37, 38, 39]) &&
      children.type.name === "Payment"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37]) &&
      children.type.name === "ViewPayment"
    ) {
      return def;
    } else if (
      !includesAny(perms, [38]) &&
      children.type.name === "AddPayment"
    ) {
      return def;
    } else if (
      !includesAny(perms, [39]) &&
      children.type.name === "EditPayment"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37, 38, 39]) &&
      children.type.name === "Journal"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37]) &&
      children.type.name === "ViewJournal"
    ) {
      return def;
    } else if (
      !includesAny(perms, [38]) &&
      children.type.name === "AddJournal"
    ) {
      return def;
    } else if (
      !includesAny(perms, [39]) &&
      children.type.name === "EditJournal"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37, 38, 39]) &&
      children.type.name === "Expense"
    ) {
      return def;
    } else if (
      !includesAny(perms, [37]) &&
      children.type.name === "ViewExpense"
    ) {
      return def;
    } else if (
      !includesAny(perms, [38]) &&
      children.type.name === "AddExpense"
    ) {
      return def;
    } else if (
      !includesAny(perms, [39]) &&
      children.type.name === "EditExpense"
    ) {
      return def;
    } else if (
      !includesAny(perms, [40, 41, 42]) &&
      children.type.name === "Users"
    ) {
      return def;
    } else if (
      !includesAny(perms, [40]) &&
      (children.type.name === "ViewUser" ||
        children.type.name === "UserActivities")
    ) {
      return def;
    } else if (
      !includesAny(perms, [41]) &&
      children.type.name === "AddUser"
    ) {
      return def;
    } else if (
      !includesAny(perms, [42]) &&
      children.type.name === "EditUser"
    ) {
      return def;
    }
    // else if (
    //   children.type.name === "UnAuthorized" ||
    //   children.type.name === "NotFound"
    // ) {
    //   return children;
    // } else {
    //   return <Navigate to="/NotFound" />;
    // }
    // } else {
    //   if (
    //     children.type.name === "ViewStore" ||
    //     children.type.name === "AddStore" ||
    //     children.type.name === "EditStore" ||
    //     children.type.name === "ViewInventory" ||
    //     children.type.name === "AddOpeningBal" ||
    //     children.type.name === "InStock" ||
    //     children.type.name === "OutStock" ||
    //     children.type.name === "TransferStock" ||
    //     children.type.name === "ViewPart" ||
    //     children.type.name === "AddPart" ||
    //     children.type.name === "EditPart" ||
    //     // children.type.name === "Quotes" ||
    //     children.type.name === "ViewQuotation" ||
    //     // children.type.name === "AddQuotation" ||
    //     children.type.name === "EditQuotation" ||
    //     children.type.name === "ViewShipment" ||
    //     children.type.name === "Shipment" ||
    //     children.type.name === "ConvertQuotation" ||
    //     children.type.name === "SpecialOrders" ||
    //     children.type.name === "SpecialOrder" ||
    //     children.type.name === "ViewReceiveLog" ||
    //     children.type.name === "ReceiveLog" ||
    //     children.type.name === "SalesReturns" ||
    //     children.type.name === "ViewSaleOrder" ||
    //     children.type.name === "ViewSalesReturn" ||
    //     children.type.name === "AddSalesReturn" ||
    //     children.type.name === "EditSaleOrder" ||
    //     children.type.name === "EditSalesReturn" ||
    //     children.type.name === "ViewPurchaseOrder" ||
    //     children.type.name === "AddPurchaseOrder" ||
    //     children.type.name === "EditPurchaseOrder" ||
    //     children.type.name === "ViewAccount" ||
    //     children.type.name === "AddAccount" ||
    //     children.type.name === "EditAccount" ||
    //     children.type.name === "ViewCustomer" ||
    //     children.type.name === "ViewSale" ||
    //     children.type.name === "ViewSO" ||
    //     children.type.name === "AddCustomer" ||
    //     children.type.name === "EditCustomer" ||
    //     children.type.name === "ViewSupplier" ||
    //     children.type.name === "ViewPurchase" ||
    //     children.type.name === "ViewPO" ||
    //     children.type.name === "AddSupplier" ||
    //     children.type.name === "PartAssign" ||
    //     children.type.name === "EditSupplier" ||
    //     children.type.name === "ViewEmployee" ||
    //     children.type.name === "AddEmployee" ||
    //     children.type.name === "EditEmployee" ||
    //     children.type.name === "ViewReceipt" ||
    //     children.type.name === "AddReceipt" ||
    //     children.type.name === "EditReceipt" ||
    //     children.type.name === "ViewPayment" ||
    //     children.type.name === "AddPayment" ||
    //     children.type.name === "EditPayment" ||
    //     children.type.name === "ViewJournal" ||
    //     children.type.name === "AddJournal" ||
    //     children.type.name === "EditJournal" ||
    //     children.type.name === "ViewExpense" ||
    //     children.type.name === "AddExpense" ||
    //     children.type.name === "EditExpense" ||
    //     children.type.name === "ViewUser" ||
    //     children.type.name === "UserActivities" ||
    //     children.type.name === "EditUser"
    //   ) {
    //     return na;
    //   } else if (
    //     includesAny(perms, [5000]) &&
    //     children.type.name === "Overview"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5001, 5002, 5003]) &&
    //     children.type.name === "Stores"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5004, 5005, 5006]) &&
    //     children.type.name === "Inventory"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5007, 5008, 5009]) &&
    //     children.type.name === "Parts"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5013, 5014, 5015]) &&
    //     children.type.name === "Sales"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5014]) &&
    //     children.type.name === "AddSaleOrder"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5010, 5011, 5012]) &&
    //     children.type.name === "Quotes"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5011]) &&
    //     children.type.name === "AddQuotation"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5016, 5017, 5018]) &&
    //     children.type.name === "Purchase"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5019, 5020, 5021]) &&
    //     children.type.name === "Account"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5022, 5023, 5024]) &&
    //     children.type.name === "Customers"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5025, 5026, 5027]) &&
    //     children.type.name === "Supplier"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5028, 5029, 5030]) &&
    //     children.type.name === "Employee"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5031, 5032, 5033]) &&
    //     children.type.name === "Receipt"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5034, 5035, 5036]) &&
    //     children.type.name === "Payment"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5037, 5038, 5039]) &&
    //     children.type.name === "Journal"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5040, 5041, 5042]) &&
    //     children.type.name === "Expense"
    //   ) {
    //     return children;
    //   } else if (
    //     includesAny(perms, [5043, 5044, 5045]) &&
    //     children.type.name === "Users"
    //   ) {
    //     return children;
    //   }
    // }
  }

  // else if (
  //   userData["role"] === "admin" &&
  //   (children.type.name === "Employee" ||
  //     children.type.name === "Customers" ||
  //     children.type.name === "Inventory" ||
  //     children.type.name === "AddInventory" ||
  //     children.type.name === "AddPart" ||
  //     children.type.name === "EditPart" ||
  //     children.type.name === "In_Stock" ||
  //     children.type.name === "Out_Stock" ||
  //     children.type.name === "Inventory")
  // ) {
  //   return <Navigate to="/ecommerce" />;
  // }
  // else if (
  //   userData["role"] === "manager" &&
  //   (children.type.name === "Employee" ||
  //   children.type.name === "Customers" ||
  //   children.type.name === "Inventory" ||
  //   children.type.name === "AddInventory" ||
  //   children.type.name === "AddPart" ||
  //   children.type.name === "EditPart" ||
  //   children.type.name === "In_Stock" ||
  //   children.type.name === "Out_Stock" ||
  //   children.type.name === "ViewInventory")
  // ) {
  //   return <Navigate to="/ecommerce" />;
  // }

  return children;
};

export default ProtectedRoute;
